<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Recibos</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select mt-1" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>

        <campaign-select v-model="filterCampaign" all-filter="Todas las campañas" :label="null" />

        <div>
          <base-input v-model="mixSearchQuery" class="mt-1" placeholder="Buscar..." prepend-icon="fas fa-search" />
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" @sort-change="sortChange">
        <el-table-column label="Número de Pedido" min-width="148px" prop="number" sortable>
          <template #default="{ row }">
            {{ row.order.code }}
          </template>
        </el-table-column>

        <el-table-column label="Cotización de Dólar" min-width="110px" prop="dollarQuotation" sortable>
          <template #default="{ row }">
            {{ row.dollarQuotation | toCurrencyARS }}
          </template>
        </el-table-column>

        <el-table-column label="Productor" min-width="150px" prop="producer" sortable>
          <template #default="{ row }">
            <div v-if="row.order.producer">
              <router-link
                v-if="$can('show', 'producers')"
                :to="{ name: 'ProducerShow', params: { id: row.order.producer.id } }"
                class="h5"
              >
                {{ row.order.producer.businessName }}
              </router-link>
              <p v-else>{{ row.order.producer.businessName }}</p>
            </div>
            <div v-if="row.order.producer.distributor">
              <small>{{ row.order.producer.distributor.name }}</small>
            </div>
            <div v-if="row.order.producer.distributor.seller">
              <small>{{ row.order.producer.distributor.seller.name }}</small>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Campaña" min-width="140px" prop="campaign" sortable>
          <template #default="{ row }">
            <div>{{ row.order.campaign.name }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Total (USD)" min-width="120px" prop="total" sortable>
          <template #default="{ row }">
            <div>{{ row.total | toCurrencyUSD }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Total (ARS)" min-width="120px" prop="total" sortable>
          <template #default="{ row }">
            <div>{{ row.totalInPesos | toCurrencyARS }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Estado" min-width="98px" prop="state" sortable>
          <template #default="{ row }">
            <span v-if="row.compliance === false" class="text-danger font-weight-bold">Pendiente</span>
            <span v-else class="text-success font-weight-bold">Confirmado</span>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="100px">
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="row.compliance === true"
              :to="{ name: 'ReceiptShow', params: { receiptId: row.id } }"
              title="ver"
              class="btn base-button btn-outline-info btn-sm"
            >
              <i class="fas fa-eye"></i>
            </router-link>
            <router-link
              v-if="row.order.stateId === STATE_ACCEPTED && $can('update', 'receipts')"
              :to="{ name: 'ReceiptEdit', params: { receiptId: row.id } }"
              title="Generar recibo"
              class="btn base-button btn-outline-primary btn-sm"
            >
              <i class="fas fa-pen"></i>
            </router-link>
            <button
              v-if="row.order.stateId !== STATE_FINALIZED && $can('destroy', 'receipts')"
              title="Eliminar"
              class="btn base-button btn-outline-danger btn-sm"
              @click="deleteRow(row.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ pagination.total }} recibos</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :show-first-page-button="true"
        :show-last-page-button="true"
        :total="pagination.total"
        class="pagination-no-border"
        @input="changePage"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, Select, Option } from 'element-ui';

import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import PaginationOnServerMixin from '@/mixins/paginationOnServerMixin';
import { STATE_ACCEPTED, STATE_FINALIZED } from '@/util/constants/orders.js';

import DeleteRowFromTableMixin from '../../../mixins/deleteRowFromTableMixin';

export default {
  name: 'ReceiptsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
    CampaignSelect,
  },

  mixins: [PaginationOnServerMixin, DeleteRowFromTableMixin],

  props: {
    campaignId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      tableData: [],
      modelName: 'receipt',
      resourceName: 'receipts',
      STATE_ACCEPTED,
      STATE_FINALIZED,
      filterCampaign: null,
    };
  },

  watch: {
    campaignId: {
      immediate: true,
      handler() {
        this.fetchTableData();
      },
    },

    filterCampaign: {
      handler() {
        this.fetchTableData();
      },
    },
  },

  methods: {
    fetchTableData() {
      this.pagination.perPage = this.perPage || this.pagination.perPage;
      this.pagination.currentPage = this.page || this.pagination.currentPage;

      const params = {
        include: ['order.campaign', 'order.producer.distributor.seller', 'concept_payments'],
        'filter[search]': this.mixSearchQuery || this.$route.params.orderId,
        'filter[campaign]': this.campaignId || this.filterCampaign,
        append: ['total-receipt'],
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
        sort: this.sort || this.defaultSort,
      };

      this.$services
        .resource('receipts')
        .get(params)
        .then((res) => {
          this.setMeta(res.data.meta);
          return res.data.data;
        })
        .then((data) => (this.tableData = data.receipts));
    },
  },
};
</script>

<style scoped>
::v-deep .el-table__expand-column .cell {
  width: 20px;
}

::v-deep .el-table__expanded-cell p {
  word-break: break-word;
  white-space: normal;
}
</style>
